// D30 (1) (roles prod promotion, Stage 3, 2026-09-25): the location search on the two
// device-location maps (Device Management's edit dialog and Asset View > Info). It reuses the
// Mapbox search box of the solution wizard's default-location picker: the geocoder plugin is
// loaded as a script in public/index.html and read here as window.MapboxGeocoder.
//
// Mapbox's free "temporary" search results may not be stored, so the search only MOVES THE
// MAP: the page drops a draggable pin at the result, and its existing Save writes the pin the
// user confirms - never the search result itself (plan decision D30, Mapbox terms).

// The geocoder gives a result's centre as [longitude, latitude]; the device forms keep
// { lng, lat }. Converting in ONE place keeps the order right (it was swapped once, D15).
export const centerToLngLat = (center) => ({
  lng: Number(center[0]),
  lat: Number(center[1]),
});

// Results are biased towards the solution's default location, which the solution wizard
// saves as [longitude, latitude]; undefined when the solution has none.
export function proximityOf(defaultLocation) {
  if (!Array.isArray(defaultLocation) || defaultLocation.length < 2) return undefined;
  const longitude = Number(defaultLocation[0]);
  const latitude = Number(defaultLocation[1]);
  if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) return undefined;
  return { longitude, latitude };
}

// Adds the search box to `map`; onPick({ lng, lat }) runs when the user picks a result.
// Returns the control, or null when the geocoder script is not loaded (the map still works).
export function addLocationSearch(map, mapboxgl, { defaultLocation, onPick }) {
  const Geocoder = typeof window !== "undefined" ? window.MapboxGeocoder : undefined;
  if (!map || !Geocoder) return null;
  const proximity = proximityOf(defaultLocation);
  const geocoder = new Geocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl,
    marker: false, // the page drops its own, draggable pin
    // A fixed bias towards the solution; without one the geocoder follows the map view.
    ...(proximity ? { proximity, trackProximity: false } : {}),
  });
  map.addControl(geocoder, "top-left");
  geocoder.on("result", (e) => {
    const center = e && e.result && e.result.center;
    if (Array.isArray(center) && center.length >= 2) onPick(centerToLngLat(center));
  });
  return geocoder;
}
